import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addExportConfig, updateExportConfig, destroyExportConfig } from 'services/exports/duck';


class ExportableCalloutWithTreemap extends React.PureComponent {
    constructor(props) {
        super(props);

        if (!props.exportName) {
            console.warn('ExportableCalloutWithTreemap: Missing exportName from callout with change'); // eslint-disable-line no-console
        }
    }

    componentDidMount() {
        if (this.props.exportName) {
            this.props.addExportConfig({
                exportName: this.props.exportName,
                type: 'callout-with-treemap',
                title: this.props.title,
                value: this.props.value
            });
        }
    }

    componentDidUpdate() {
        if (this.props.exportName) {
            this.props.updateExportConfig({
                exportName: this.props.exportName,
                type: 'callout-with-treemap',
                title: this.props.title,
                value: this.props.value
            });
        }
    }

    componentWillUnmount() {
        if (this.props.exportName) {
            this.props.destroyExportConfig({
                exportName: this.props.exportName
            });
        }
    }

    render() {
        return null;
    }
}

ExportableCalloutWithTreemap.propTypes = {
    exportName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default connect(null, {
    addExportConfig,
    updateExportConfig,
    destroyExportConfig
})(ExportableCalloutWithTreemap);



// WEBPACK FOOTER //
// ./src/containers/callouts/ExportableCalloutWithTreemap.js